import { useAuthStore } from '@/features/auth';
import { useBusinessContextStore } from '@/features/business-context';

/**
 * Returns the effective business ID to use for data queries.
 * - For regular users (owner/staff): returns their assigned business_id
 * - For super admins: returns the selected business from BusinessContextStore
 */
export function useEffectiveBusinessId(): string | null {
  const user = useAuthStore((state) => state.user);
  const selectedBusinessId = useBusinessContextStore(
    (state) => state.selectedBusinessId
  );

  if (!user) return null;

  // Super admins use the business context selector
  if (user.role === 'super_admin') {
    return selectedBusinessId;
  }

  // Regular users use their assigned business
  return user.business_id || null;
}